<template>
  <div class="animal-carousel">
    <carousel
              :autoplay="true"
              :autoplayHoverPause="true"
              :perPage=1
              :autoplayTimeout=5000
              :navigationNextLabel="'>'"
              :navigationPrevLabel="'<'"
              :navigationEnabled="false"
              :paginationEnabled="true"
              :loop="true"
              v-if="items.length > 1">
      <slide v-for="item,key in items" :key="key" >
        <div :style="'background-image: url(\''+item.url+'\')'" style="background-position: center center; padding-top: 66%; background-size: cover;"></div>
      </slide>
    </carousel>
    <div :style="'background-image: url(\''+items[0].url+'\'); background-position: center center'" style="background-position: center center; padding-top: 66%; background-size: cover;" v-else></div>
  </div>
</template>

<script>
  export default {

    props: {
      items: {
        require: true,
        type: Array
      }
    },
     mounted() {

        // remove the dot titles hack - https://github.com/SSENSE/vue-carousel/issues/445
        setTimeout(() => {
            const dots = document.getElementsByClassName('VueCarousel-dot');
            for (let index = 0; index < dots.length; index += 1) { const element = dots[index]; element.title = ''; }
        }, 1000);

    }
  }
</script>